import { emptyApi } from "./emptyApi";

export type ChatAiToggleResponse = {
  is_ai_enabled: boolean;
  ai_disabled_by: string | null;
};

export const chatAiToggleApi = emptyApi.injectEndpoints({
  endpoints: (build) => ({
    toggleChannelAi: build.mutation<
      ChatAiToggleResponse,
      { channelId: string }
    >({
      query: ({ channelId }) => ({
        url: `/api/inkle/messaging/channel/${channelId}/ai/toggle/`,
        method: "POST",
      }),
    }),
  }),

  overrideExisting: false,
});

export const { useToggleChannelAiMutation } = chatAiToggleApi;
